export default "__VITE_ASSET__6883c196__"